import { render } from "./BecomeACreatorValuesTitle.vue?vue&type=template&id=26aa2536"
import script from "./BecomeACreatorValuesTitle.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorValuesTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__